'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'jet-fighter';
var width = 576;
var height = 512;
var aliases = ["fighter-jet"];
var unicode = 'f0fb';
var svgPathData = 'M168 0l96 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-69.8 0 161.3 176 90.9 0c18 0 35.7 3.6 52.3 10.5l57.6 24c11.9 5 19.7 16.6 19.7 29.5s-7.8 24.6-19.7 29.5l-57.6 24c-16.6 6.9-34.4 10.5-52.3 10.5l-90.9 0-161.3 176 69.8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-128 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l24 0 0-176-29.1 0-45.8 38.1c-1.4 1.2-3.3 1.9-5.1 1.9L8 360c-4.4 0-8-3.6-8-8L0 160c0-4.4 3.6-8 8-8l72 0c1.9 0 3.7 .7 5.1 1.9l45.8 38.1 29.1 0 0-176-24 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l32 0zm8 208l-48 0c-1.9 0-3.7-.7-5.1-1.9l-45.8-38.1-61.1 0 0 80 48 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-48 0 0 80 61.1 0 45.8-38.1c1.4-1.2 3.3-1.9 5.1-1.9l318.4 0c15.8 0 31.5-3.1 46.2-9.2l57.6-24c6-2.5 9.8-8.3 9.8-14.8s-3.9-12.3-9.8-14.8l-57.6-24c-14.6-6.1-30.3-9.2-46.2-9.2L176 208zm0-16L333.8 192 176 19.8 176 192zm0 128L176 492.2 333.8 320 176 320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faJetFighter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;